module.exports = __webpack_public_path__ + "static/media/overview-of-the-weight-loss-surgery-3-x@3x.f762bca0.jpg";